import { Maybe } from '@vendorflow/types'
import { MediumsEnum } from 'features/firebase/Firebase.constants'
import { SwitchboardEndpointsEnum } from 'features/switchboard/Switchboard.types'
import { convertToSwitchboardEndpoint } from 'features/tenants-endpoints-addresses/TenantsEndpointsAddresses.services'
import { SB_PREFIX } from 'features/tenants-endpoints/TenantsEndpoints.constants'
import { ServicesEnum } from '@vendorflow/types/lib/types/Radar'

export function normalizeToEndpointEnum(val: Maybe<MediumsEnum | SwitchboardEndpointsEnum>) {
  return val ? convertToSwitchboardEndpoint(val) : val
}

export function convertMediumToSwitchboardEndpoint(medium: Maybe<MediumsEnum>) {
  if (!medium) return medium
  return (SB_PREFIX + medium) as SwitchboardEndpointsEnum
}

export function getEndpointDisplayName(medium: SwitchboardEndpointsEnum, eldService: Maybe<ServicesEnum>) {
  switch (medium) {
    case SwitchboardEndpointsEnum.WHATSAPP:
      return 'WA'
    case SwitchboardEndpointsEnum.TELEGRAM:
      return 'TG'
    case SwitchboardEndpointsEnum.SMS:
      return 'SMS'
    case SwitchboardEndpointsEnum.ELD:
      switch (eldService) {
        case ServicesEnum.SAMSARA:
          return 'Sam'
        case ServicesEnum.GEOTAB:
          return 'Geo'
        default:
          return 'ELD'
      }
  }
}
